import { withAssetPrefix } from "gatsby";

const STYLESHEET_ID = "rs-icomoon-stylesheet";

let injected = false;
let loadedPromise: Promise<void> | null = null;

export const isIcoMoonStylesheetReady = (): boolean => injected;

/**
 * Charge le CSS IcoMoon (classes `.icon-*` + @font-face) depuis `/fonts/icomoon.css`.
 * Non bloquant pour le rendu : `media="print"` puis bascule en `all` au onload.
 */
export const ensureIcoMoonStylesheet = (): Promise<void> => {
  if (typeof document === "undefined") return Promise.resolve();
  if (loadedPromise) return loadedPromise;

  loadedPromise = new Promise<void>((resolve) => {
    const existing = document.getElementById(
      STYLESHEET_ID
    ) as HTMLLinkElement | null;

    if (existing) {
      injected = true;
      if ((existing.sheet as CSSStyleSheet | null) !== null) {
        resolve();
      } else {
        existing.addEventListener("load", () => resolve(), { once: true });
        existing.addEventListener("error", () => resolve(), { once: true });
      }
      return;
    }

    const link = document.createElement("link");
    link.id = STYLESHEET_ID;
    link.rel = "stylesheet";
    link.href = withAssetPrefix("/fonts/icomoon.css");
    link.media = "print";
    link.onload = () => {
      link.media = "all";
      resolve();
    };
    link.onerror = () => {
      link.media = "all";
      resolve();
    };
    document.head.appendChild(link);
    injected = true;
  });

  return loadedPromise;
};
